import React, { useState,useEffect } from "react";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import Cookies from "js-cookie";
import axios from "axios";
import { url } from "../../../../../../../../../App";
import styles from "../PD/pd.module.css";
import { ToastContainer, toast } from "react-toastify";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from '@mui/icons-material/Download';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {useParams } from "react-router-dom";

const RecordingDisplay = () => {
    const { loanid } = useParams();
    const [videoUrls, setVideoUrls] = useState([]);
    const { borrowerData } = useBorrowerContext();
    const fetchedBorrowerDetails = borrowerData.borrower;
    const [open, setOpen] = React.useState(false);

    const mappedLoanId = () => {
        axios
            .post(url + "/videosdk/download/recording", {
                token: Cookies.get('Token'),
                email: Cookies.get('Email'),
                borrower_Id: fetchedBorrowerDetails.borrower_uniqueno,
                loan_Id: loanid
            })
            .then((res) => {
                console.log(res);
                if (res.data.auth === false) {
                    toast.error(res.data.message);
                    setVideoUrls([]);
                } else {
                    // console.log(res);
                    setVideoUrls(res.data.recordings);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    let downloadCount = 1;

    const downloadVideo = async (key) => {
        try {
            setOpen(true);
            const response = await axios.post(`${url}/videosdk/download/screen/recording`, {
                key,
                token: Cookies.get('Token'),
                email: Cookies.get('Email'),
            });
            const downloadUrl = response.data.url;
            const extension = key.split('.').pop();
            const fileName = `video${downloadCount}.${extension}`;
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            downloadCount++;
            setOpen(false);
        } catch (err) {
            setOpen(false);
            console.error('Error downloading video:', err);
        }
    };

    useEffect(() => {
        mappedLoanId();
        //eslint-disable-next-line
    }, [loanid]);

    return (
        <>
            <hr className="hori-line" />
            <div className={styles.imageContainer}>
                <div className={styles.recordingDisplay}>
                    {(videoUrls && videoUrls.length > 0) ? (
                        [...videoUrls].reverse().map((video, index) => (
                            <Card key={index} sx={{ maxWidth: 335 }}>
                                <video width="100%" height="240" controls>
                                    <source src={video.url} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                                <CardContent>
                                    <div style={{ display: "flex" }}>
                                        <div>
                                            <Typography gutterBottom variant="h8" component="div">
                                                <p><strong>Time: </strong>{video.videoTime}</p>
                                                <p><strong>Date: </strong>{video.videoDate}</p>
                                            </Typography>
                                            <Typography gutterBottom variant="h8" component="div">
                                                <p><strong>Nearby Location: </strong> {video.videoLocation}</p>
                                            </Typography>
                                        </div>
                                        <div>
                                            <Tooltip title="Download Recording">
                                                <DownloadIcon style={{ color: "#034ea1", fontSize: "1.5rem" }} onClick={() => downloadVideo(video.key)}>
                                                </DownloadIcon>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        ))
                    ) : (
                        <h1 style={{ textAlign: "center" }}>Recording Not Available</h1>
                    )}
                </div>
            </div>
            <ToastContainer />
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default RecordingDisplay;
